import { Navigate, RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "../components/CustomLoader";
import CustomerLayout from "../layouts/Customer.Layout";
import CustomerTickets from "../pages/Customer/CustomerTickets";
import TicketDetails from "../pages/Customer/components/ticketDetails";

const CustomerLogin = lazy(() => import("../pages/Customer/Login"));
const CustomerDashboard = lazy(() => import("../pages/Customer/Dashboard"));
const CustomerFeedbacks = lazy(() => import("../pages/Customer/Feedbacks"));

const withSuspense = (Component: React.FC) => (
  <Suspense fallback={<Loader force={true} />}> <Component /> </Suspense>
);

export const customerRoutes: RouteObject[] = [
  {
    path: "/",
    element: <CustomerLayout />,
    children: [
      { path: "customer/login", element: withSuspense(CustomerLogin) },

      { path: "/", element: <Navigate to="/customer/tickets" /> },
      // { path: "dashboard", element: withSuspense(CustomerDashboard) },
      { path: "/customer/feedbacks", element: withSuspense(CustomerFeedbacks) },
      { path: "/customer/tickets", element: withSuspense(CustomerTickets) },
      { path: "/customer/tickets-details/:id", element: withSuspense(TicketDetails) },
    ],
  },
]; 